import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormsService } from '../../service/FormService';
import { useAuthStore } from '../../store/storeAuth';
import { FluxService } from '../../service/FluxService';
import Title from '../../components/PublishedForm/Text/Text';
import ShortText from '../../components/PublishedForm/ShortText/ShortText';
import Image from '../../components/PublishedForm/Image/Image';
import Output from '../../components/PublishedForm/Output/Output';
import Input from '../../components/PublishedForm/Input/Input';
import LoadingSpinner from '../../components/UI/LoadingSpinner';
import FluxpromptLogo from '../../assets/icons/fluxprompt-logo.svg';
import { useNotificationStore } from '../../store/storeNotifications';
import List from '../../components/PublishedForm/List/List';

const Nodes = ({
  nd,
  inputs,
  outputs,
  setInputs,
  setOutputs,
  onSubmit,
  formSubmitted,
}: any) => {
  const { type, data, position, id } = nd;
  const { label } = data;

  if (type === 'title') {
    return (
      <Title
        key={id}
        data={{
          label: data?.title || '',
          fullData: data,
          style: {
            maxWidth: nd?.width ? nd?.width - 16 : 'auto',
            width: '100%',
            // // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'listNode') {
    return (
      <List
        key={id}
        input={inputs}
        setInputs={setInputs}
        data={{
          label: data?.title || '',
          fullData: data,
          question: data?.question || '',
          options: data?.options || [],
          type: data?.type || 'dropdown',

          style: {
            maxWidth: nd?.width ? nd?.width - 16 : 'auto',
            // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'shortText') {
    return (
      <ShortText
        key={id}
        data={{
          label: data?.title,
          subtitle: data?.subtitle,
          text: data?.text || '',
          fullData: data,
          style: {
            maxWidth: nd?.width ? nd?.width - 16 : 'auto',
            width: '100%',
            // // position: 'absolute',
            // backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'image') {
    return (
      <Image
        key={id}
        data={{
          label: data?.title,
          subtitle: data?.subtitle,
          fullData: data,
          url: data?.url || '',
          style: {
            maxWidth: nd?.width ? nd?.width - 16 : 'auto',
            width: '100%',
            // // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'outputDisplay') {
    return (
      <Output
        key={id}
        output={outputs?.find(
          (out: any) => out?.outputId === data?.selectedFlow,
        )}
        setOutputs={setOutputs}
        data={{
          label: data?.title,
          fullData: data,
          subtitle: data?.subtitle,
          style: {
            maxWidth: nd?.width ? nd?.width - 16 : 'auto',
            width: '100%',
            // // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'inputDisplay') {
    return (
      <Input
        key={id}
        input={inputs}
        setInputs={setInputs}
        data={{
          label: data?.title,
          fullData: data,
          subtitle: data?.subtitle,
          style: {
            maxWidth: nd?.width ? nd?.width - 16 : 'auto',
            width: '100%',
            // // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'submit') {
    return (
      <Box>
        <Button disabled={formSubmitted} onClick={onSubmit} variant="contained">
          {formSubmitted ? 'Submitted' : 'Submit'}
        </Button>
      </Box>
    );
  }

  return (
    <Box
      key={id}
      sx={{
        // position: 'absolute',
        maxWidth: nd?.width ? nd?.width - 16 : 'auto',
        width: '100%',
        backgroundColor: 'white',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        mb: '16px',
        // left: position.x,
        // top: position.y,
      }}
    >
      {label}
    </Box>
  );
};

const PublishedForm = () => {
  const [isLoadin, setIsLoading] = useState(false);
  const [form, setForm] = useState<any>({});
  const [flow, setFlow] = useState<any>();
  const [nodes, setNodes] = useState<any[]>([]);
  const params = useParams<{ formId: string }>();
  const [inputs, setInputs] = useState<any>([]);
  const [outputs, setOutputs] = useState<any>([]);
  const [formLoading, setFormLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const user = useAuthStore(state => state.user);
  const [errorType, setErrorType] = useState('');

  const setNotification = useNotificationStore(state => state.setNotification);
  const navigate = useNavigate();

  useEffect(() => {
    const getFlow = async () => {
      setIsLoading(true);
      try {
        const response = await FormsService.getFormPublished(params.formId!);

        const nodes = response.data.publishedNodes;

        const mapNodes = nodes.map((node: any) => {
          if (node.type === 'inputDisplay') {
            const getVarInputNodes = response?.data?.flow?.nodes
              ?.filter((nd: any) => nd.type === 'varInputNode')
              ?.map((nd: any) => {
                return {
                  id: nd.id,
                  label: nd.data.label,
                };
              });
            return {
              ...node,
              data: {
                ...node.data,
                varInputNodes: getVarInputNodes,
              },
            };
          }

          if (node.type === 'outputDisplay') {
            const getVarInputNodes = response?.data?.flow?.nodes
              ?.filter((nd: any) => nd.type === 'outputObjectNode')
              ?.map((nd: any) => {
                return {
                  id: nd?.id,
                  label: nd?.data?.label,
                };
              });

            return {
              ...node,
              data: {
                ...node.data,
                varOutputNodes: getVarInputNodes,
              },
            };
          }
          return {
            ...node,
          };
        });

        const flowInputs = response?.data?.flow?.nodes
          .filter((node: any) => node.type === 'varInputNode')
          ?.map((node: any) => ({
            inputId: node?.id,
            inputText: '',
          }));

        const flowOutputs = response?.data?.flow?.nodes
          .filter((node: any) => node.type === 'outputObjectNode')
          ?.map((node: any) => ({
            outputId: node?.id,
            text: '',
          }));
        setInputs(flowInputs);
        setOutputs(flowOutputs);
        setNodes(mapNodes);
        setFlow(response?.data?.flow);
        setForm(response?.data);
      } catch (error: any) {
        if (error?.message === 'You need to be logged in to access this form') {
          setErrorType('login');
        }

        if (error?.message === 'Form not found') {
          setErrorType('notFound');
        }
        if (
          error?.message ===
          'Sorry, this form is not published or its not available'
        ) {
          setErrorType('notPublished');
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (params.formId) {
      getFlow();
    }
  }, [params.formId]);

  const calculatePositions = (nodes: any) => {
    const sortedNodes = nodes.sort(
      (a: any, b: any) => a.position.y - b.position.y,
    );
    const minY = Math.min(...sortedNodes.map((node: any) => node.position.y));

    const adjustedNodes = sortedNodes.map((node: any) => {
      return {
        ...node,
        position: {
          x: node.position.x < 0 ? 0 : node.position.x,
          y: node.position.y - minY < 0 ? 0 : node.position.y - minY,
        },
      };
    });

    const groupedNodes: any[] = [];
    const range = 70;
    adjustedNodes.forEach((node: any) => {
      const group = groupedNodes.find((g: any) =>
        g.some((n: any) => Math.abs(n.position.y - node.position.y) <= range),
      );
      if (group) {
        group.push(node);
      } else {
        groupedNodes.push([node]);
      }
    });

    let currentY = 0;
    const marginY = 20;
    const marginX = 10;

    const finalNodes: any[] = [];
    groupedNodes.forEach(group => {
      let currentX = 0;
      group.forEach((node: any) => {
        finalNodes.push({
          ...node,
          position: {
            x: currentX,
            y: currentY,
          },
        });
        currentX += (node?.width || 100) + marginX;
      });
      const maxHeight = Math.max(
        ...group.map((node: any) => node?.height || 100),
      );
      currentY += maxHeight + marginY;
    });

    // sort groupedNodes by position X
    const sorted = groupedNodes.map(newGroup =>
      newGroup.sort((a: any, b: any) => a.position.x - b.position.x),
    );

    return { finalNodes, groupedNodes: sorted };
  };

  const onSubmit = async () => {
    setFormLoading(true);
    try {
      const response = await FluxService.formApi(flow?.id!, form?.id, {
        variableInputs: inputs,
      });

      // set new output
      setFormSubmitted(true);

      setOutputs(response?.data?.message);
    } catch (error: any) {
      setFormSubmitted(false);
      setNotification({
        message: error?.message,
        type: 'error',
        duration: 3000,
      });
    } finally {
      setFormLoading(false);
    }
  };

  const { finalNodes: adjustedNodes, groupedNodes } = calculatePositions(nodes);

  if (isLoadin) {
    return <LoadingSpinner height="100vh" />;
  }

  return (
    <Box
      sx={{
        maxWidth: '932px',

        margin: '0 auto',
        p: '20px 16px',
      }}
    >
      {errorType && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              maxWidth: '400px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              bgcolor: '#fff',
              boxShadow: '0 0 10px rgba(0,0,0,0.1)',
              gap: '30px',
              p: '20px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              height: '400px',
            }}
          >
            <Box>
              <img
                style={{
                  maxWidth: '350px',
                  width: '100%',
                  height: '100px',
                }}
                src={FluxpromptLogo}
                alt="Fluxprompt Logo"
              />
            </Box>

            {errorType === 'login' && (
              <>
                <Typography mb={'24px'} variant="h1">
                  You need to be logged in to access this form
                </Typography>

                <Button
                  onClick={() => {
                    navigate('/login');
                  }}
                  variant="contained"
                  fullWidth
                >
                  Login
                </Button>
              </>
            )}

            {(errorType === 'notPublished' || errorType === 'notFound') && (
              <>
                <Typography variant="h1">
                  Sorry, this form is not published or its not available
                </Typography>

                <Button
                  onClick={() => {
                    navigate('/login');
                  }}
                  variant="contained"
                  fullWidth
                >
                  {user?.id ? 'Go To Dashboard' : 'Login '}
                </Button>
              </>
            )}
          </Box>
        </Box>
      )}
      {/* {adjustedNodes?.map((nd: any, index) => {
    return <Nodes key={index} nd={nd} />;
  })} */}

      {formLoading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 1000,
            backgroundColor: 'rgba(255,255,255,0.5)',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Box>
        {groupedNodes?.map((group: any, index) => {
          if (group.length === 1) {
            return (
              <Nodes
                key={index}
                inputs={inputs}
                outputs={outputs}
                setInputs={setInputs}
                setOutputs={setOutputs}
                onSubmit={onSubmit}
                formSubmitted={formLoading}
                nd={group[0]}
              />
            );
          }

          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'space-between',

                w: '100%',

                '@media (max-width: 600px)': {
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                },
              }}
            >
              {group.map((nd: any, index: any) => {
                return (
                  <Nodes
                    key={index}
                    nd={nd}
                    inputs={inputs}
                    outputs={outputs}
                    setInputs={setInputs}
                    setOutputs={setOutputs}
                    onSubmit={onSubmit}
                    formSubmitted={formLoading}
                  />
                );
              })}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PublishedForm;
